import $ from 'jquery';

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');

// Breakpoints
var breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 1012,
    xl: 1440
};


/**
 * Main nav extender
 */
$('#navbarResponsive').on('hide.bs.collapse', function () {
    $(this).closest(".navbar").removeClass("navbar-mobile-shown");
}).on('show.bs.collapse', function () {
    $(this).closest(".navbar").addClass("navbar-mobile-shown");
});


/**
 * Minimizes the padding of an element in dependency of the scroll position.
 * Typically used for sticky header navs.
 */
$('.scroll-minimizer').each(function () {
    var minimum = 0.1;
    const paddingTop = parseInt($(this).css('padding-top'));
    const paddingBottom = parseInt($(this).css('padding-bottom'));
    const paddingTotal = paddingTop + paddingBottom;
    if (!paddingTotal) return;
    const $minimizerObj = $(this);

    const scrollFunction = function () {
        const scrollRelative = 1 - Math.min($(window).scrollTop() / paddingTotal, 1 - minimum);
        const top = paddingTop * scrollRelative;
        const bottom = paddingBottom * scrollRelative;

        $minimizerObj.css({
            'padding-top': top + 'px',
            'padding-bottom': bottom + 'px',
        });
    };

    $(window).scroll(scrollFunction);
    scrollFunction();
});

/**
 * Scrolls down below the element (self) on click
 */
$('.scroll-down-self').each(function () {

    if (inBackend) return;

    $(this).css('cursor', 'pointer');
    $(this).on('click', function (event) {
        event.preventDefault();

        let offset = 50;
        const dataOffset = $(this).data('scroll-down-offset');
        if (dataOffset !== undefined) {
            offset = parseFloat(dataOffset);
        }

        $('html, body').animate({
            scrollTop: $(this).position().top + $(this).outerHeight(true) - offset,
        }, 450);

    });
});


$(".fade-scroll").each(function () {

    if (inBackend) {
        return;
    }

    var minVisibility = 0.0;
    var maxVisibility = 1.0;
    if ($(this).data("min")) {
        minVisibility = parseFloat($(this).data("min"));
    }
    if ($(this).data("max")) {
        minVisibility = parseFloat($(this).data("max"));
    }

    var $container = $(this);
    var direction = $container.data('direction');
    if (!direction) {
        direction = 'out';
    }

    $(window).on("scroll resize", function () {
        calculateVisibility();
    });
    calculateVisibility();

    function calculateVisibility() {

        if ($(window).width() < breakpoints.md) {
            $container.css('opacity', 1);
            return;
        }

        var scroll = $container.offset().top - $(document).scrollTop();
        var height = Math.min($container.height(), $(window).height() / 2);
        var offset = 50;

        var startFade, visibility;

        if (direction === 'out') {
            startFade = Math.max(-scroll + offset, 0);
            visibility = Math.min(1 - startFade / height, 1);
        } else {
            startFade = Math.max($(window).height() - scroll - offset, 0);
            visibility = Math.min(startFade / height, 1);
        }

        // Clamp low visibility
        visibility = (visibility * (maxVisibility - minVisibility)) + minVisibility;
        var grayscale = (1 - visibility) * 100;

        $container.css('opacity', visibility);
        $container.css('filter', 'grayscale(' + grayscale + '%)');
    }

});


/**
 * Open external links in new window
 */
$("a").filter('[href^="http"], [href^="https"], [href^="//"]')
    .not('[href*="' + window.location.host + '"]')
    .attr('rel', 'noopener noreferrer')
    .attr('target', '_blank')
    .addClass("external-link");





/**
 * Category menu accordion
 */
$(".category-menu").each(function () {

    var $categories = $(this).find("li.category");

    $categories.each(function () {

        var $category = $(this);
        var $projects = $(this).find("ul.projects");

        $category.data("projects", $projects);

        // Hide initially
        $projects.hide();
        $category.data("hidden", true);
        $category.addClass("menu-hidden");

        var $title = $(this).find(".category-title");

        // Cursor pointer
        $title.css("cursor", "pointer");

        // Append click event
        $title.on("click", function () {

            $categories.each(function () {

                // Check if current and if not hidden
                var $currentCategory = $(this);
                if ($currentCategory[0] === $category[0] && $currentCategory.data("hidden")) {

                    // Show
                    $currentCategory.removeClass("menu-hidden");
                    $currentCategory.data("hidden", false);
                    $(this).data("projects").slideDown(250);

                } else {

                    // Hide
                    $currentCategory.addClass("menu-hidden");
                    $currentCategory.data("hidden", true);
                    $(this).data("projects").slideUp(250);
                }

            });
        });
    });

});
